import { STATE } from "@core/state";
import { $, $$, body } from "@utils/dom";
import { on, off } from "@utils/listener";
import EventEmitter2 from "eventemitter2";

export const CLASSNAME = "--js-site-nav-opened";
export const OPENING_CLASSNAME = '--js-site-nav-opening';

class SiteNav {
  constructor(el, emitter) {
    this.el = el;
    this.emitter = emitter;
    this.bg = $('.site-nav__bg', this.el);
    this.triggers = [...$$(`[aria-controls="${this.el.id}"]`)];
    this.menuItems = [...$$(".menu-item-has-children", this.el)].map(el => new SiteNavMenuItem(el, this.emitter));

    this._isChildOfWindmill = this.el.closest('[data-windmill="container"]') ? true : false;
    this._opened = false;
    this._scrollY = 0;

    this._close = this.close.bind(this);
    this._handleTriggers = this._handleTriggers.bind(this);
    this._handleKeyDown = this._handleKeyDown.bind(this);
    this._onCloseCompleted = this._onCloseCompleted.bind(this);
  }

  init(){
    this._bindEvents();
  }

  destroy() {
    if( this.menuItems ) this.menuItems.forEach(el => el.destroy());

    body.classList.remove(CLASSNAME);

    this.el = null;
    this.emitter = null;
    this.bg = null;
    this.triggers = null;
    this.menuItems = null;

    this._isChildOfWindmill = null;
    this._opened = false;
    this._scrollY = 0;

    this._close = null;
    this._handleTriggers = null;
    this._handleKeyDown = null;
    this._onCloseCompleted = null;
  }
  stop() {
    if( this._isChildOfWindmill ) {
      this._unbindEvents();
      this.destroy();
    }
  }

  _bindEvents() {
    if( this.triggers ) on(this.triggers, "click", this._handleTriggers);
    if( this.el ) on(window, "keydown", this._handleKeyDown);

    this.emitter.on("SiteNav.toggle", this._handleTriggers);
    this.emitter.on("SiteSearch.open", this._close);
    this.emitter.on("SiteCart.open", this._close);
    this.emitter.on("SiteWishlist.open", this._close);
  }
  _unbindEvents() {
    if( this.triggers ) off(this.triggers, "click", this._handleTriggers);
    if( this.el ) off(window, "keydown", this._handleKeyDown);

    this.emitter.off("SiteNav.toggle", this._handleTriggers);
    this.emitter.off("SiteSearch.open", this._close);
    this.emitter.off("SiteCart.open", this._close);
    this.emitter.off("SiteWishlist.open", this._close);

  }

  open() {
    // if SiteNav is already opened, do nothing
    if (this._opened === true) return;
    this._opened = true;

    // dispatch to state current status
    STATE.dispatch("SITE_NAV", this._opened);

    // save scrollY
    this._scrollY = window.scrollY;

    // unbind close completed callback
    if (this.bg) off(this.bg, "transitionend", this._onCloseCompleted);

    // inform <body> that SiteNav is opened
    body.classList.add(CLASSNAME);
    body.classList.add(OPENING_CLASSNAME);

    setTimeout(()=>{
      body.classList.remove(OPENING_CLASSNAME);
    }, 10);

    // stop page scroll & site-nav open
    this.emitter.emit("SiteScroll.stop");
    this.emitter.emit("SiteNav.open");

    // inform each triggers that SiteNav is opened
    this.triggers.forEach(btn => {
      btn.setAttribute("aria-expanded", true);
      btn.classList.add("is-active");
    });

    // set SiteNav visible for screen readers
    this.el.setAttribute("aria-hidden", false);
  }
  close() {
    // if SiteNav isn't opened, do nothing
    if (this._opened === false) return;
    this._opened = false;

    // dispatch to state current status
    STATE.dispatch("SITE_NAV", this._opened);

    // inform triggers that SiteNav is closed
    this.triggers.forEach(btn => {
      btn.setAttribute("aria-expanded", false);
      btn.classList.remove("is-active");
    });

    // close callback
    if (this.bg) {
      off(this.bg, "transitionend", this._onCloseCompleted);
      on(this.bg, "transitionend", this._onCloseCompleted);
    }

    // inform <body> that SiteNav is closed
    body.classList.remove(CLASSNAME);

    // restore previous scrollY
    window.scrollTo({top: this._scrollY, behavior: 'auto'});

    // update site-scroll & site-nav close
    this.emitter.emit('SiteScroll.update');
    this.emitter.emit("SiteNav.close");

    this._onCloseCompleted();
  }
  toggle() {
    // regular SiteNav toggle handling
    if (this._opened === true) this.close();
    else this.open();
  }

  _handleTriggers(event) {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }

    this.toggle();
  }
  _handleKeyDown(event) {
    if (this._opened === true && (event.key === "Escape" || event.key === "Esc")) {
      this.close();
    }
  }
  _onCloseCompleted() {
    if (this._opened === true) return;

    // restart page scroll
    this.emitter.emit("SiteScroll.start");

    // hide SiteNav from screen readers
    this.el.setAttribute("aria-hidden", true);
  }

  // getters
  get opened() {
    return this._opened;
  }
}

class SiteNavMenuItem extends EventEmitter2 {
  constructor(el, emitter) {
    super();

    this.el = el;
    this.emitter = emitter;
    this.opened = false;
    this.activated = false;

    this._toggle = this._toggle.bind(this);
    this._open = this._open.bind(this);
    this._close = this._close.bind(this);
    this._activate = this._activate.bind(this);
    this._deactivate = this._deactivate.bind(this);

    this.init();
  }

  destroy() {

    this._unbindEvents();

    this.opened = null;
    this.activated = null;

    this.el = null;
    this.togglers = null;
    this.lotties = null;
  }
  init() {
    this.toggler = $('button, a', this.el);

    this._bindEvents();
  }

  _bindEvents() {
    on(this.toggler, "click", this._toggle);
    this.emitter.on("SiteNav.open", this._activate);
    this.emitter.on("SiteNav.close", this._deactivate);

  }
  _unbindEvents() {
    off(this.toggler, "click", this._toggle);
    this.emitter.off("SiteNav.open", this._activate);
    this.emitter.off("SiteNav.close", this._deactivate);
  }

  _toggle(event){
    if(event) {
      event.preventDefault();
      event.stopPropagation();
    }

    if(this.el.classList.contains('--opened')){
      this._close();
    } else {
      this._open();
    }
  }

  _activate(){
    if(this.activated || !this.opened) return;

    this.activated = true;
  }

   _deactivate(){
    if( !this.activated ) return;

    this.activated = false;
  }

  _open(){
    if( this.opened ) return;

    this.opened = true;
    this.el.classList.add('--opened');

    this._activate();

    this.emit("open", this);
  }

  _close(){
    if( ! this.opened ) return;

    this.opened = false;
    this.el.classList.remove('--opened');

    this._deactivate();

    this.emit("close", this);
  }
}

export default SiteNav;
